module.exports = __webpack_public_path__ + "static/img/viral_11.7ae517e5.jpg";